import Vue                       from 'vue'
import Storage                   from 'vue-web-storage'
import VueMeta                   from 'vue-meta'
import VueMask                   from 'v-mask'
import App                       from '@/App'
import vuetify                   from '@/plugins/vuetify'
import { resetRouter, router }   from '@/router'
import { i18n, setI18nLanguage } from '@/lang/lang'
import DataStorePlugin           from '@/lib/data/dataStore/plugin/DataStorePlugin'
import UtilsPlugin               from '@/lib/utils/plugin'
import EventBus                  from '@/lib/events/eventBus'
import Enums                     from '@/lib/enums/plugin'
import { themeUtils }            from '@/lib/utils'
import DayjsPlugin               from '@/lib/date/plugin'
import EnvMixin                  from '@/mixins/env'
import RouteMiddleware           from '@/lib/middleware/RouteMiddleware'
import RouterReadyMiddleware     from '@/router/middleware/RouterReadyMiddleware'
import LangMiddleware            from '@/router/middleware/LangMiddleware'
import { setupBugsnag }          from '@/lib/services/Bugsnag'
import DataStore                 from '@/lib/data/dataStore/DataStore'
import Snotify                   from '@/theme/default/components/common/vue-snotify/index'

import '@mdi/font/css/materialdesignicons.css'
import './theme/default/components/common/vue-snotify/styles/material.css'
import './App.css'

require('@openfonts/roboto_greek')

const DefaultLayout = () => themeUtils.importThemeComponent('layouts/DefaultLayout')
// const DefaultLayout = import(/* webpackChunkName: "DefaultLayout" */ '@/theme/default/layouts/DefaultLayout')

const initVue = () => {
  resetRouter()

  Vue.component('DefaultLayout', DefaultLayout)
  Vue.component('DefaultLayout', DefaultLayout)

  Vue.mixin(EnvMixin)

  Vue.use(EventBus)
  Vue.use(DataStorePlugin)
  Vue.use(UtilsPlugin)
  Vue.use(DayjsPlugin)
  Vue.use(Enums)
  Vue.use(VueMask)
  Vue.use(Storage, {
    prefix : `${ process.env.VUE_APP_STORAGE_PREFIX }_`,
    drivers: ['session', 'local']
  })
  Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
  })
  Vue.use(Snotify, {
    config: {
      timeout        : 3000,
      showProgressBar: true,
      pauseOnHover   : true,
      titleMaxLength : 28,
      bodyMaxLength  : 150,
      backdrop       : -1
    },
    options: {
      maxOnScreen  : 8,
      maxAtPosition: 8,
      maxHeight    : 500,
      newOnTop     : true,
      position     : 'centerTop'
    }
  })

  window.Vue = new Vue({
    el        : '#app',
    directives: {},
    mixins    : [],
    data () {
      return {}
    },
    beforeMount () {
      setI18nLanguage(process.env.VUE_APP_I18N_LOCALE)
      this.$router.onReady(RouterReadyMiddleware)
      router.beforeEach(RouteMiddleware({ LangMiddleware }, true, this))
      router.beforeEach(RouteMiddleware())
    },
    beforeCreate () {},
    created () {
      this.$bus.$on('app-show-notification', this.showNotification)
    },
    mounted () {},
    beforeDestroy () {
      this.$bus.$on('app-show-notification', this.showNotification)
    },
    methods: {
      showNotification (data) {
        this.$snotify[data.type](data.body, data.title, {
          timeout        : data.hasOwnProperty('timeout') ? data.timeout : 2000,
          showProgressBar: data.hasOwnProperty('showProgressBar') ? data.showProgressBar : true,
          closeOnClick   : data.hasOwnProperty('closeOnClick') ? data.closeOnClick : true,
          pauseOnHover   : data.hasOwnProperty('pauseOnHover') ? data.pauseOnHover : true,
          position       : data.position ? data.position : 'centerTop',
          buttons        : data.buttons ? data.buttons : [],
          icon           : data.icon ? data.icon : null
        })
      }
    },
    i18n,
    router,
    vuetify,
    render: h => h(App)
  })

  if (process.env.NODE_ENV === 'production') {
    Vue.config.productionTip = false
    Vue.config.devtools = false
    Vue.config.debug = false
    Vue.config.silent = true
  }
}

const init = (data = {}) => {
  DataStore.App.Config = { ...DataStore?.App?.Config ?? {}, ...data?.data ?? {} }

  initVue()
  setupBugsnag()
}

init()
